import React from "react";
import { RegistrationDetails } from "./RegistrationDetails";
import { RelatedEntities } from "./RelatedEntities";
import { BusinessRelation } from "./BusinessRelation";
import { Banks } from "./Banks";
import { Insurance } from "./Insurance";
import { Financials } from "./Financials";

import { VATInformation } from "./VATInformation";
import { AuthorizedSignatories } from "./AuthorizedSignatories";
import { KeyPersonnel } from "./KeyPersonnel";
import { CompanyOwnershipStructure } from "./CompanyOwnershipStructure";
import { TaxDetails } from "./TaxDetails";

export const BriefCompanyDetails = ({ company }) => {
  const status = company?.companyID === undefined
  ? "listing"
  : company?.verifiedCompany != null
    ? "verified"
    : (company?.claimed && "claimed") ||
    (company?.draft && "warning")

  // Check if status is "pending"
  if (status === "claimed") {
    return renderClaimedStatus();
  } else {
    return renderNonClaimedStatus();
  }

  function renderNonClaimedStatus(){   
  let bankDetails = company?.bankDetails;
  let companyTaxDetails = company?.company_tax;
  let ownershipCompany = company?.ownershipCompany;
  let authorizedSignDetails = company?.authorizedSignDetails
  let companyKeyPersonnel = company?.companyKeyPersonnel
  let relatedEntity = company?.relatedEntity
  let businessRelation = company?.businessRelation
  let insuranceDetails = company?.insuranceDetails

  return (
    <>
      <div className="flex gap4 flex-col">
        <RegistrationDetails company={company} />
        {/* {(company?.TRN_no || company?.VAT_certificate) && (
          <VATInformation company={company} />
        )} */}

        {ownershipCompany?.length > 0 && (
          <CompanyOwnershipStructure
            ownershipCompany={ownershipCompany}
          />
        )}
        {authorizedSignDetails?.length > 0 && (
          <AuthorizedSignatories
            authorizedSignatories={authorizedSignDetails}
          />
        )}
        {companyKeyPersonnel?.length > 0 && (
          <KeyPersonnel companyKeyPersonnel={companyKeyPersonnel} />
        )}
      </div>

      {relatedEntity?.length > 0 && (
        <div className="mt-6">
          <RelatedEntities relatedEntity={relatedEntity} />
        </div>
      )}

      {businessRelation?.length > 0 && (
        <div className="mt-6">
          <BusinessRelation businessRelation={businessRelation} />
        </div>
      )}
      {bankDetails?.length > 0 && (
        <div className="mt-6">
          <Banks bankDetails={bankDetails} />
        </div>
      )}
      {
        companyTaxDetails?.length > 0 && (
          <div className="mt-6">
            <TaxDetails companyTaxDetails={companyTaxDetails} />
          </div>
        )
      }
      {insuranceDetails?.length > 0 && (
        <div className="mt-6">
          <Insurance insuranceDetails={insuranceDetails} />
        </div>
      )}
      {company?.financialDetails?.length > 0 && (
        <div className="mt-6">
          <Financials financialDetails={company?.financialDetails[0]} />
        </div>
      )}
    </>
  );
}

function renderClaimedStatus(){ 
  let companyTaxDetails = company?.company_tax?.filter(
    (item) => item?.is_deleted === 0
  );
  let bankDetails = company?.bankDetails?.filter(
    (item) => item?.bankID?.is_deleted === 0
  );
  let ownershipCompany = company?.ownershipCompany?.filter(
    (item) => item?.ownershipID?.ownership_compID?.is_deleted === 0 || item?.ownershipID?.ownership_indID?.is_deleted === 0
  );
  let authorizedSignDetails = company?.authorizedSignDetails?.filter(
    (item) => item?.Authorized_signID?.is_deleted === 0
  );
  let companyKeyPersonnel = company?.companyKeyPersonnel?.filter(
    (item) => item?.key_personnelID?.is_deleted === 0
  );
  let relatedEntity = company?.relatedEntity?.filter(
    (item) => item?.related_entityID?.is_deleted === 0
  );
  let businessRelation = company?.businessRelation?.filter(
    (item) => item?.business_relationID?.is_deleted === 0
  );
  let insuranceDetails = company?.insuranceDetails?.filter(
    (item) => item?.insuranceID?.is_deleted === 0
  );
  return (
    <>
      <div className="flex gap4 flex-col">
        <RegistrationDetails company={company} />
        {/* {(company?.TRN_no || company?.VAT_certificate) && (
          <VATInformation company={company} />
        )} */}

        {ownershipCompany?.length > 0 && (
          <CompanyOwnershipStructure
            ownershipCompany={ownershipCompany}
          />
        )}
        {authorizedSignDetails?.length > 0 && (
          <AuthorizedSignatories
            authorizedSignatories={authorizedSignDetails}
          />
        )}
        {companyKeyPersonnel?.length > 0 && (
          <KeyPersonnel companyKeyPersonnel={companyKeyPersonnel} />
        )}
      </div>

      {relatedEntity?.length > 0 && (
        <div className="mt-6">
          <RelatedEntities relatedEntity={relatedEntity} />
        </div>
      )}

      {businessRelation?.length > 0 && (
        <div className="mt-6">
          <BusinessRelation businessRelation={businessRelation} />
        </div>
      )}
      {bankDetails?.length > 0 && (
        <div className="mt-6">
          <Banks bankDetails={bankDetails} />
        </div>
      )}
      {
        companyTaxDetails?.length > 0 && (
          <div className="mt-6">
            <TaxDetails companyTaxDetails={companyTaxDetails} />
          </div>
        )
      }
      {insuranceDetails?.length > 0 && (
        <div className="mt-6">
          <Insurance insuranceDetails={insuranceDetails} />
        </div>
      )}
      {company?.financialDetails?.length > 0 && (
        <div className="mt-6">
          <Financials financialDetails={company?.financialDetails[0]} />
        </div>
      )}
    </>
  );
}
};